/** 课程是否免费（分） */
export function isFreeCourse(course) {
  if (!course) return true
  return !course.fee || course.fee === 0
}

/** 是否可直接进入学习页（免费或已购买） */
export function canViewCourseContent(course) {
  if (isFreeCourse(course)) return true
  return course.isAcquired > 0
}

/** 列表/卡片主按钮文案 */
export function coursePrimaryActionLabel(course, isLoggedIn) {
  if (!course) return '查看'
  if (course.isAcquired > 0) return '继续学习'
  if (isFreeCourse(course)) return '查看课程'
  if (!isLoggedIn) return '登录学习'
  return '购买学习'
}
